<template>
  <div class="container-fluid w-100">
    <navbar :title="$t('observation_reports.title')" class="mb-2"/>
      <report-search
        :user="user"
        :templates="templates"
        @report-selected="onReportSelected"
        @add-template="editMode = true"
        @search="fetchReport"
      />
      <Transition name="fade">
        <div v-if="results.length > 0" class="trip-results mt-2" style="height: 24em">
              <div class="row nopads mt-2 mb-2">
                <!-- MAP -->
                  <div class="col-md-6 d-flex flex-column pb-0" style="height: 22em">
                          <div class="flex-fill position-relative" style="height: 22em; border-radius: .75em; border: 1px solid #BCBCBC; overflow: hidden; position: sticky">
                              <map-container
                                  ref="mapContainer"
                                  :find-user="false"
                                  @on-map-changed="onMapChanged"
                                  @on-marker-tap="showPointDetails"
                              />
                          </div>
                  </div>
                  <!-- CHART -->
                  <div class="col-sm-6 nopads" style="overflow: hidden; position: sticky; height: 22em">
                      <observation-value-charts
                          ref="valueChart"
                          :title="selectedReport.name"
                          :lower-limit="selectedReport.lower_alert_limit"
                          :upper-limit="selectedReport.upper_alert_limit"
                          :results="results"
                          @item-clicked="onItemClicked"
                      />
                </div>
              </div>
          <div class="col-12 mt-2 my-3">
            <report-list
                ref="resultList"
                :upper-limit="selectedReport ? selectedReport.upper_alert_limit : null"
                :lower-limit="selectedReport ? selectedReport.lower_alert_limit : null"
                :results="results"
                @row-clicked="observationClicked"
            />
          </div>
        </div>
      </Transition>
      <observation-report-editor
          v-if="editMode"
          @close="editMode = false"
          @close-and-update="fetchReportTemplates"
      />

      <div
        v-if="loading"
        id="loader"
        class="spinner"
      />
  </div>
</template>


<script>
import {restApi} from '../../mixins/RestApiMixin'
import ReportSearch from "@/components/observation/reports/ReportSearch";
import ReportList from "@/components/observation/reports/ReportList";
import ObservationReportEditor from "@/components/observation/reports/ObservationReportEditor";
import MapContainer from "@/components/map/MapContainer";
import {mapHelper} from "@/components/mixins/MapMixin";
import {timeUtils} from "@/components/mixins/TimeUtils";
import ObservationValueCharts from "@/components/observation/reports/ObservationValueCharts";
import Navbar from "@/components/utils/Navbar";

export default {
    name: 'ObservationReports',
    components: {
        Navbar,
        ObservationValueCharts,
        MapContainer,
        ObservationReportEditor,
        ReportList,
        ReportSearch
    },
    mixins: [restApi, mapHelper, timeUtils],
    props: {
        user: {
            type: Object,
            default: null
        },
    },
    data: function () {
        return {
            templates: [],
            results: [],
            powerStation: null,
            loading: false,
            lastSearchedParams: null,
            editMode: false,
            selectedReport: null,
            map: null
        }
    },
    mounted() {
        this.fetchReportTemplates()
    },
    methods: {
        onMapChanged(map) {
            this.map = map
            if (this.map && this.results.length > 0) {
                this.drawResultsOnMap()
            }
        },
        showPointDetails(data) {
            const pointItem = this.results.find(item => data.id === item.id)
            let bubbleData = []
            bubbleData[this.$t('observations.created_time')] = this.toLocalTime(pointItem.created_time)
            bubbleData[this.$t('observations.value')] = pointItem.value
            this.map.showInfoBubble(this.OBSERVATION, data.id, pointItem.type.name, bubbleData, pointItem.geometry.point.y, pointItem.geometry.point.x)
        },
        fetchReportTemplates: function () {
            this.editMode = false
            this.loading = true
            this.templates = []
            this.restFetch(this.observationReportTemplateUrl, this.handleTemplates, () => {
                this.loading = false
            })
        },
        handleTemplates: function (response) {
            if (response && response.data) {
                this.templates = response.data
            }
            this.loading = false
        },
        closeAndUpdate: function () {
            this.editMode = false
            this.fetchReport(this.lastSearchedParams)
        },
        fetchReport: function (param) {
            this.editMode = false
            this.loading = true
            this.results = []
            this.lastSearchedParams = param
            this.restFetchParams(this.observationUrl, param, this.handleResults, () => {
                this.loading = false
            })
        },
        handleResults: function (response) {
            if (response && response.data) {
                this.results = response.data
                this.drawResultsOnMap()
            }
            this.loading = false
        },
        onReportSelected(id) {
            this.selectedReport = this.templates.find(item => item.id === id)
        },
        drawResultsOnMap() {
            if (this.map) {
                this.hideMapItems()
                this.results.forEach(item => {
                    let icon = this.beyondLimit(item.value) ? this.map.getMarkerStore().getSolidCircleIcon() :
                        this.map.getMarkerStore().getNeutralCircleIcon()
                    this.map.showMapMarker(item.id, this.OBSERVATION, item.geometry.point.y, item.geometry.point.x, icon)
                })
               this.map.zoomToGroup(this.OBSERVATION)
            }
        },
        hideMapItems() {
            if (this.map) {
                this.map.removeMapItemsByType(this.OBSERVATION)
            }
        },
        beyondLimit(value) {
            if (!this.selectedReport) {
                return false
            }
            return (this.selectedReport.upper_alert_limit && parseFloat(value) > this.selectedReport.upper_alert_limit) ||
                (this.selectedReport.lower_alert_limit && parseFloat(value) < this.selectedReport.lower_alert_limit)
        },
        observationClicked(item) {
            if (this.map) {
                this.map.zoomToPosition(item.geometry.point.y, item.geometry.point.x, 13)
            }
            this.selectItem(item)
        },
        onItemClicked(index) {
            if (this.map && index >= 0 && index < this.results.length) {
                const item = this.results[index]
                this.map.zoomToPosition(item.geometry.point.y, item.geometry.point.x, 13)
                this.$refs.resultList.selectRow(index)
                this.$refs.resultList.scrollToRow(index)
            }
        },
        selectItem(selected) {
            const index = this.results.findIndex(item => item.id === selected.id)
            if (index > 0) {
                this.$refs.valueChart.setSelected(index)
            }
        }
    }
}
</script>
